import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import {
	EARLY_FREEDOM_TARGET_FALLBACK,
	EARLY_FREEDOM_TARGET_MAX,
	EARLY_FREEDOM_TARGET_MIN,
	EARLY_FREEDOM_TARGET_STEP,
} from "web_myplann/Inspiration/constants";
import { useResetStateOnOpen } from "web_myplann/Shared/Hooks/useResetStateOnOpen";

const R = Resources.Inspiration.EarlyFreedom.QuickSheet;

type Props = {
	open: boolean;
	onClose: () => void;
	onSubmit: (targetExpenses: number) => void;
};

export const EarlyFreedomQuickSheet: FC<Props> = ({
	open,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const [targetExpenses, setTargetExpenses] = useResetStateOnOpen(
		open,
		EARLY_FREEDOM_TARGET_FALLBACK,
	);

	return (
		<InspirationSheet
			open={open}
			preventScrollOnClose
			onClose={onClose}
			title={t(R.title)}
			description={t(R.description)}
			primaryLabel={t(R.submit)}
			onPrimary={() => onSubmit(targetExpenses)}
		>
			<BoxedSliderField
				label={t(R.sliderLabel)}
				value={targetExpenses}
				onChange={setTargetExpenses}
				min={EARLY_FREEDOM_TARGET_MIN}
				max={EARLY_FREEDOM_TARGET_MAX}
				step={EARLY_FREEDOM_TARGET_STEP}
				hint={t(R.hint)}
			/>
		</InspirationSheet>
	);
};
